import { useQuery } from "@tanstack/react-query";
import { StableFeature } from "@worldwidewebb/client-world";
import { getEntities } from "../../api/entities/entities";

export default function useEntities(worldId: string) {
  const {
    isLoading,
    isFetching,
    error,
    data: entities,
  } = useQuery<StableFeature[]>({
    queryKey: ["entity", worldId],
    queryFn: () => getEntities(worldId),
  });

  return {
    isLoading: isLoading || isFetching,
    error,
    entities,
  };
}
